/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import "./ProductDetails.module.css"
import Slider from "react-slick";
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { CartContext } from '../../Context/CartContext';
export default function () {
    const [productDetails, setProductDetails] = useState(null);
    const [isLoading, setIsloading] = useState(false);
    let {id} = useParams();
    async function getProducDetails(productId) {
        setIsloading(true)
        let {data} = await axios.get(`https://ecommerce.routemisr.com/api/v1/products/${productId}`);
            setProductDetails(data.data);
            setIsloading(false)
        }
        let {addProduct} = useContext(CartContext);
        
    useEffect(()=> {
        if(id) {
            getProducDetails(id); 
        }
    }, [id])
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        };
    return (
            <>
            <div className="row d-flex align-items-center justify-content-center" style={{marginBottom:"80px"}}>
            {isLoading?<div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div> : <>
                <div className="col-md-4" >
                    <Slider {...settings}>
                    {productDetails?.images.map((img, index) => (
    <img className='w-100 product-img' key={index} src={img} alt={`Product image ${index + 1}`} />
))}

                    </Slider>
                </div>    
                <div className="col-md-8 mt-5" >
                <h3 className='h5'>{productDetails?.title.split(" ").slice(0, 10).join(" ")}</h3>
                <p className='text-muted p-2'>{productDetails?.description.split(" ").slice(0, 10).join(" ")}</p>
                <div className="d-flex justify-content-between">
                        <span className='text-muted'>{productDetails?.price} EGP</span>
                        <span >
                            <i className='fas fa-star rating-color'></i> 
                            {productDetails?.ratingsAverage}
                        </span>
                </div>
                <button onClick={() => {
                    addProduct(productDetails?._id);
                    }} className='btn bg-main text-white w-100'>+ Add</button>

            </div>
            </>}
                
        </div>
            </>
    )
}
